export default "__VITE_ASSET__06b4ee18__"